import type { ProgressNoteEditFormValues } from './progressNoteEditSchema'

/**
 * "Effectively blank" (spec 2026-08-11-ai-draft-actions-design.md): every
 * narrative field empty AND no structured rows other than un-edited chart
 * carry-forward (`external: true` without the `updated` flag — the hydrate
 * seed, not something the doctor typed). Used by the editor's "Load saved AI
 * draft" action to skip the replace-content confirm in the recovery case (a
 * wiped/blank note).
 *
 * Deliberately ignores header metadata (noteDate, visitType, encounterDetails)
 * and billing — out of scope per the spec. Billing is NOT preserved by the
 * merge when the draft carries its own suggestion (it virtually always does):
 * a billing-only edit on an otherwise blank note loads without a confirm, an
 * accepted edge.
 */
export function isEffectivelyBlankNote(values: ProgressNoteEditFormValues): boolean {
  const s = values.summary
  const narrativeEmpty =
    !s.chiefComplaint.trim() &&
    s.hpi.every((p) => !p.text.trim()) &&
    s.ros.length === 0 &&
    !s.assessment.trim() &&
    !s.plan.trim() &&
    !s.mdm.trim()
  if (!narrativeEmpty) return false
  return (
    values.conditions.every((r) => r.external) &&
    values.allergies.every((r) => r.external && !r.updated) &&
    values.procedures.length === 0 &&
    values.medications.length === 0 &&
    values.observations.length === 0 &&
    values.serviceRequests.length === 0 &&
    values.followUps.every((f) => !f.text.trim())
  )
}
